/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Verdict = {
    Agree: 'agree',
    Disagree: 'disagree',
} as const;
export type Verdict = typeof Verdict[keyof typeof Verdict];


export function instanceOfVerdict(value: any): boolean {
    for (const key in Verdict) {
        if (Object.prototype.hasOwnProperty.call(Verdict, key)) {
            if (Verdict[key as keyof typeof Verdict] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VerdictFromJSON(json: any): Verdict {
    return VerdictFromJSONTyped(json, false);
}

export function VerdictFromJSONTyped(json: any, ignoreDiscriminator: boolean): Verdict {
    return json as Verdict;
}

export function VerdictToJSON(value?: Verdict | null): any {
    return value as any;
}

export function VerdictToJSONTyped(value: any, ignoreDiscriminator: boolean): Verdict {
    return value as Verdict;
}

